<template>
	<div class="fight-locked">
		<div class="fight-locked__icon">
			<div class="icon-lock" />
		</div>
		<div class="fight-locked__text">
			{{ lockedText }}
		</div>
	</div>
</template>

<script lang="ts" setup>
import useSiegeSystemRepository from "@/hooks/useSiegeSystemRepository";
import { translate } from "@/utils/translate";
import { computed } from "vue";

export type LockedType =
	| "level"
	| "explore"
	| "deploy"
	| "range"
	| "inactive-battlefield"
	| "naval-units-not-yet-available"
	| "";
// prop lockedType
const props = defineProps<{ lockedType: LockedType }>();

const lockedText = computed(() => {
	switch (props.lockedType) {
		case "level":
			return translate("ui.battle_from_level").replace(
				"{number}",
				`${useSiegeSystemRepository().unlockLevel}`,
			);
		case "explore":
			return translate("ui.explore_all_enemy_tiles");
		case "deploy":
			return translate("ui.deploy_units_to_start");
		case "range":
			return translate("ui.unit_out_of_range");
		case "inactive-battlefield":
			return translate("ui.only_one_active_battle");
		case "naval-units-not-yet-available":
			return translate("ui.naval_units_not_yet_available");
		default:
			return "";
	}
});
</script>

<style lang="scss" scoped>
.fight-locked {
	@include flex-col-center;
	gap: 0.5rem;
	width: 100%;
	height: 100%;

	&__text {
		color: rgb(242, 220, 181);
		font-size: 0.9063rem;
		text-shadow: 0.0437rem 0.0437rem 0.0625rem rgba(0, 0, 0, 0.6);
	}

	.icon-lock {
		width: 2rem;
		height: 2rem;
	}
}
</style>
